import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";
import StatisticsBox from "../../../../../components/StatisticsBox";

const StatsBoxes = ({ data }) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
			<StatisticsBox
				sx={{
					flex: "0 1 30.12%",
					minWidth: "unset",
					"@media (min-width: 1620px)": {
						flex: "0 1 15.12%",
					},
				}}
				title={t("cargos_entered")}
				value={data.entered}
				color="#000000"
			/>
			<StatisticsBox
				sx={{
					flex: "0 1 30.12%",
					minWidth: "unset",
					"@media (min-width: 1620px)": {
						flex: "0 1 15.12%",
					},
				}}
				title={t("cargos_sold")}
				value={data.sold}
				color="#AE78D6"
			/>
			<StatisticsBox
				sx={{
					flex: "0 1 30.12%",
					minWidth: "unset",
					"@media (min-width: 1620px)": {
						flex: "0 1 15.12%",
					},
				}}
				title={t("cargos_unsold")}
				value={data.notSold}
				color="#A6A6A6"
			/>
			<StatisticsBox
				sx={{
					flex: "0 1 30.12%",
					minWidth: "unset",
					"@media (min-width: 1620px)": {
						flex: "0 1 15.12%",
					},
				}}
				title={t("total_margin") + " (€)"}
				value={data.margin}
				color="#92D050"
			/>
			<StatisticsBox
				sx={{
					flex: "0 1 30.12%",
					minWidth: "unset",
					"@media (min-width: 1620px)": {
						flex: "0 1 15.12%",
					},
				}}
				title={t("average_margin") + " (€)"}
				value={data.avgMargin}
				color="#F07C00"
			/>
			<StatisticsBox
				sx={{
					flex: "0 1 30.12%",
					minWidth: "unset",
					"@media (min-width: 1620px)": {
						flex: "0 1 15.12%",
					},
				}}
				title={t("income") + " (€)"}
				value={data.income}
				color="#0069B4"
			/>
		</Box>
	);
};

export default StatsBoxes;
